import { Box, Card } from '@wix/design-system';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header as AuthorizedHeader } from './Header/Header';
import s from './Layout.scss';

export const AppStructure = ({ children }) => (
  <>
    <Box className={s.contentRoot}>
      <Card className={s.cardLeft}>
        {children}
        <Box direction="vertical" className={s.pageContent}>
          <Outlet />
        </Box>
      </Card>
    </Box>
  </>
);

export const AppLayout = () => {
  return (
    <AppStructure>
      <AuthorizedHeader />
    </AppStructure>
  );
};
